import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { Button, Container } from "shards-react";

const Errors = () => {
  const [redirect, setredirect] = useState(false);
  if (redirect) return <Redirect to="/" />;
  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <div className="error">
        <div className="error__content">
          <h2>500</h2>
          <h3>Algo no ha funcionado como debería.</h3>
          <p>Por favor, inténtalo de nuevo más tarde.</p>
          <Button pill onClick={() => setredirect(true)}>
            &larr; Página Principal
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default Errors;
